import componentHelpers from '../componentLibrary/componentHelpers.js'
import * as $ from 'jquery';

class ProgressbarService {
    selector;
    eventBroker;
    params;

    nodes = [];

    clear() {
        this.nodes = [];
    }

    constructor(progressbarSelector, eventBroker) {
        this.selector = progressbarSelector;
        this.eventBroker = eventBroker;
    }

    bind() {
        this.eventBroker.subscribe("showProgressBar", this.onShowProgressBar.bind(this));
    }

    onShowProgressBar(params) {
        if (params.showProgressBar) {
            $(".sid-progressbar-outer").css("visibility", "visible");
            let progressPercent = this.#getProgress(params.nodeId) * 100;
            if (params.progressPercent)
                progressPercent = params.progressPercent;
            const rounded = Math.round(progressPercent);
            $(".sid-progressbar-inner").css("width", progressPercent + "%");
            $(".sid-progressbar-outer")
                .attr("aria-valuenow", rounded)
                .attr("aria-valuetext", componentHelpers.uiText({ params: this.params }, "si_pts_dialog_progress_valuetext", "{{percent}} percent complete", { percent: rounded }));
        }
        else {
            $(".sid-progressbar-outer").css("visibility", "hidden");
        }
    }

    register(nodeId) {
        this.nodes.push(nodeId);
    }

    initProgressbar(params) {
        this.params = params;
        var $progressbarouter = $("<div class='sid-progressbar-outer bg-light' role='progressbar' aria-valuemin='0' aria-valuemax='100' aria-valuenow='0'></div>")
            .attr("aria-label", componentHelpers.uiText({ params }, "si_pts_dialog_progress_label", "Test progress"));
        var $progressbarinner = $("<div class='sid-progressbar-inner bg-primary'></div>");
        $progressbarinner.css("width", "0%");
        $progressbarouter.append($progressbarinner);

        $(this.selector).append($progressbarouter);
    }

    #getProgress(nodeId) {
        var total = this.nodes.length;
        var counter = 0;
        for (var index in this.nodes) {
            counter++
            if (this.nodes[index] == nodeId) {
                return counter / total;
            }
        }
        return 1;
    }
}

export { ProgressbarService }
